import React from 'react'
import { formatedDate } from '../../../utils/formatedDate'
import styled from 'styled-components'
import { StyledCard } from '../../Cards/StyledCard'
import { useTranslation } from 'react-i18next'

const StyledMetaInfoBlock = styled(StyledCard)`
  font-size: 14px;
`

const StyledInfoItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const StyledInfoItem = styled.div`
  padding: 15px 25px;
  width: 200px;
`

const StyledMetaLabel = styled.div`
  font-weight: bold;
`
export default function MetaInfoBlock({headerData}) {
    const { t } = useTranslation()
    if (!headerData) {
      return null
    }
    const isRellocation = () =>{
      return headerData.receiptType === "relocation";
    }
    return (
        <StyledMetaInfoBlock>
            <StyledInfoItemsContainer>
            <div className='d-flex justify-content-between flex-wrap'>
                <div>
                <StyledInfoItem>
                    <StyledMetaLabel>{t('goodsReceiptsTable:receiptNo')}:</StyledMetaLabel>
                    <div>{headerData.displayName}</div>
                </StyledInfoItem>
                </div>
                <div>
                <StyledInfoItem>
                    <StyledMetaLabel>{t('goodsReceiptsTable:warehouse')}:</StyledMetaLabel>
                    <div>{headerData.targetStorehouse ? headerData.targetStorehouse.displayName : null}</div>
                </StyledInfoItem>
                </div>
                {!isRellocation() &&
                  <div>
                  <StyledInfoItem>
                    <StyledMetaLabel>{t('goodsReceiptsTable:supplier')}:</StyledMetaLabel>
                    <div>{headerData.supplier ? headerData.supplier.displayName : null}</div>
                  </StyledInfoItem>
                  </div>
                }       
                <div className='d-flex justify-content-between flex-grow-1'>
                  <StyledInfoItem>
                        <StyledMetaLabel>{t('goodsReceiptsTable:expectedTimeOfArrival')}:</StyledMetaLabel>
                        <div>{formatedDate(headerData.expectedTimeOfArrival) ? formatedDate(headerData.expectedTimeOfArrival) : null}</div>
                  </StyledInfoItem>
                </div>
            </div>
            </StyledInfoItemsContainer>
        </StyledMetaInfoBlock>
    )
}